<div class="bg-[#F9F8F7] p-6">
  <div class="max-w-2xl w-full space-y-3">
    <!-- Success Banner -->
    <div class="bg-[#E8F5E9] rounded-lg p-4 flex items-center gap-3">
      <div class="flex-shrink-0">
        <mat-icon class="text-success">check</mat-icon>
      </div>
      <p class="text-[#2E7D32] font-poppins text-base font-medium mb-0">
        PAN verified successfully!
      </p>
    </div>

    <!-- Organization Name Banner -->
    <div class="bg-[#FFF3E0] rounded-lg p-4 flex items-center gap-3">
      <div class="flex-shrink-0">
        <mat-icon class="text-[#F58634]">business</mat-icon>
      </div>
      <div class="flex-1">
        <span class="text-[#E65100] font-poppins text-sm font-normal mb-0"
          >Organization Name:
        </span>
        <span class="text-[#E65100] font-poppins text-base font-semibold uppercase">
          {{ organizationName || '-' }}
        </span>
      </div>
    </div>

    <!-- Confirmation Card -->
    <div class="pt-6">
      <p class="text-[#0E1116] font-poppins text-base font-normal mb-6">
        Please confirm if this is the correct organization:
      </p>

      <!-- Action Buttons -->
      <div class="flex gap-4 justify-end">
        <app-common-button
          [text]="'Confirm & Proceed to Dashboard'"
          [icon]="'check'"
          [color]="'#F58634'"
          [variant]="'primary'"
          (onClick)="onConfirm()"
        ></app-common-button>

        <app-common-button
          text="Cancel"
          icon="close"
          [variant]="'outline'"
          (onClick)="onCancel()"
        ></app-common-button>
      </div>
    </div>
  </div>
</div>
